// extracted by mini-css-extract-plugin
export var blue = "_2b-f";
export var brand = "_2b-b";
export var darkGrey = "_2b-e";
export var disabled = "_2b-4";
export var disabledSubtle = "_2b-5";
export var error = "_2b-6";
export var green = "_2b-g";
export var grey = "_2b-d";
export var icon = "_2b-0";
export var inherit = "_2b-a";
export var lightGrey = "_2b-c";
export var orange = "_2b-i";
export var pink = "_2b-k";
export var primary = "_2b-1";
export var purple = "_2b-l";
export var red = "_2b-j";
export var secondary = "_2b-2";
export var success = "_2b-9";
export var tertiary = "_2b-3";
export var warning = "_2b-7";
export var warningSecondary = "_2b-8";
export var white = "_2b-m";
export var yellow = "_2b-h";